var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "control-city" },
    [
      _c(
        "div",
        {
          staticClass: "control-city-current",
          on: {
            click: function($event) {
              _vm.$city.isCityHeaderShown = !_vm.$city.isCityHeaderShown
            }
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.CITY.name) + "\n    "),
          _c("chevron-animated", {
            attrs: { reverse: _vm.$city.isCityHeaderShown }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "control-city-confirm" },
        [
          _c(
            "ui-dropdown",
            {
              attrs: {
                left: "",
                right: "",
                visible: !_vm.CITY_CONFIRMED && !_vm.$city.isCityHeaderShown
              }
            },
            [
              _c("p", [
                _vm._v("\n        Ваш регион доставки:\n        "),
                _c("br"),
                _vm._v(_vm._s(_vm.CITY.name) + "?\n      ")
              ]),
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c("ui-button", {
                    attrs: { text: "Да, верно" },
                    on: { click: _vm.CONFIRM_CITY }
                  }),
                  _c("ui-button", {
                    attrs: { flat: "", text: "Нет, выбрать другой" },
                    on: {
                      click: function($event) {
                        _vm.$city.isCityHeaderShown = true
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "control-city-search" },
        [
          _c(
            "ui-dropdown",
            {
              attrs: { left: "", visible: _vm.$city.isCityHeaderShown },
              on: {
                "on-close": function($event) {
                  _vm.$city.isCityHeaderShown = false
                }
              }
            },
            [_c("city-search", { on: { choose: _vm.chooseCity } })],
            1
          )
        ],
        1
      ),
      _c(
        "vue-client-only",
        [
          !_vm.adaptive.isDesktop
            ? [
                _c("modal-confirm", {
                  attrs: {
                    visible:
                      !_vm.CITY_CONFIRMED && !_vm.$city.isCityHeaderShown,
                    title: "Ваш регион доставки: <br>" + _vm.CITY.name + "?",
                    buttons: [
                      {
                        text: "Да, верно"
                        // action дергается в close
                      },
                      {
                        text: "Нет, выбрать другой",
                        flat: true,
                        action: function() {
                          return _vm.$f.showNav("city")
                        }
                      }
                    ]
                  },
                  on: { "on-close": _vm.CONFIRM_CITY }
                })
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }